import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digitally-connected',
  templateUrl: './digitally-connected.component.html',
  styleUrls: ['./digitally-connected.component.css']
})
export class DigitallyConnectedComponent implements OnInit {
  disabledbutton : boolean = false;  
  pagitionfirst : boolean = false;
  pagitionsecond : boolean = false;
  paginationthird : boolean = false;
  paginationfour : boolean = false;

  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
    this.getPaginationfirst();
  }

  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos = (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }

  
  getPaginationfirst(){
    this.pagitionsecond = false;
    this.paginationthird = false;
    this.pagitionfirst = true;
    this.paginationfour = false;
    document.getElementById("Page1").classList.add('active'); 
    document.getElementById("Page2").classList.remove('active');    
    document.getElementById("Page3").classList.remove('active');
    document.getElementById("Page4").classList.remove('active'); 
    
  }
  getPaginationsecond(){ 
    this.pagitionfirst = false;
    this.paginationthird = false;
    this.pagitionsecond = true;
    this.paginationfour = false;    
    document.getElementById("Page1").classList.remove('active');
    document.getElementById("Page2").classList.add('active');     
    document.getElementById("Page3").classList.remove('active');
    document.getElementById("Page4").classList.remove('active'); 
  }
  getPaginationthird(){ 
    this.pagitionfirst = false;
    this.paginationthird = true;
    this.pagitionsecond = false;
    this.paginationfour = false;
    document.getElementById("Page1").classList.remove('active');       
    document.getElementById("Page2").classList.remove('active');
    document.getElementById("Page3").classList.add('active');  
    document.getElementById("Page4").classList.remove('active');  
  }

  getPaginationfour(){ 
    this.pagitionfirst = false;
    this.paginationthird = false;
    this.paginationfour = true;
    this.pagitionsecond = false;
    document.getElementById("Page1").classList.remove('active');       
    document.getElementById("Page2").classList.remove('active');
    document.getElementById("Page3").classList.remove('active');  
    document.getElementById("Page4").classList.add('active');  
  }

  getPaginationnext(){
    if(this.pagitionfirst == true){
      this.getPaginationsecond();
    }
    else if(this.pagitionsecond == true){
      this.getPaginationthird();
    }
    else if(this.paginationthird== true){
      this.getPaginationfour();
    }
    else{
      this.disabledbutton= true;
    }
  }
  getPaginationPrevious(){
    if(this.paginationfour == true){
      this.getPaginationthird();
    }
    else if(this.paginationthird == true){
      this.getPaginationsecond();
    }
    else if(this.pagitionsecond == true){
      this.getPaginationfirst();
    }
    else{
      this.disabledbutton= true;
    }
  }

}
